import api from './axios'; 

const dashboardRequests = {
    getConciergeMetrics(year){
        return api.get(`/dashboard/metrics/concierge/current/${year}`)
    },
    getConciergeCommissionsMetrics(year){
        return api.get(`/dashboard/metrics/commissions/concierge/current/${year}`)
    },
    getCurrentProviderMetrics(){
        return api.get(`/dashboard/metrics/provider/current`)
    },
    getCurrentProviderCommissionsMetrics(year){
        return api.get(`/dashboard/metrics/commissions/provider/current/${year}`)
    },
    getAdminMetrics(){
        return api.get(`/dashboard/metrics/admin`, { orgContext: "global" })
    },
    getAdminChartMetrics(year){
        return api.get(`/dashboard/metrics/chart/admin/${year}`, { orgContext: "global" })
    },
};

export default dashboardRequests;
